<template>
  <a-card :bordered="false" class="m-t-10">
    <p class="fz-16 s_font_b p-b-20">
      <a-button class="m-r-10" size='small' @click="()=>{$router.go(-1)}">
        <LeftOutlined />返回
      </a-button>
      {{$route.query.type == 'add'?'创建退货单':'添加商品'}}
    </p>
    <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-item label="退货单号" name='refund_warehousing_sn'>{{form.refund_warehousing_sn}}</a-form-item>
      <a-form-item label="返回仓库" name='refund_warehouse_id'>
        <a-select v-model:value="form.refund_warehouse_id" style='width: 40%;' placeholder='请选择仓库' :disabled="pageType" @change='selectChange'>
          <a-select-option v-for='item in warehouseList' :key='item.id' :value="item.id">{{item.name}}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="库位">
        <a-select v-model:value="form.refund_warehouse_position_id" style='width: 40%;' placeholder='请选择库位' :disabled="!form.refund_warehouse_id">
          <a-select-option v-for='item in warehouseChild' :key='item.id' :value="item.id">{{item.name}}
          </a-select-option>
        </a-select>
        <a-button class='m-l-10' :disabled="!form.refund_warehouse_id" @click='form.refund_warehouse_position_id = null'>清空</a-button>
      </a-form-item>
      <a-form-item label="备注">
        <a-textarea v-model:value="form.remark" placeholder="请输入备注" :rows="4" :maxlength='100' />
      </a-form-item>
      <a-form-item label="退货人" v-if='returnee'>{{returnee}}</a-form-item>
      <a-form-item label="扫码类型" name='type'>
        <a-radio-group v-model:value="form.type" @change='form.code=""'>
          <a-radio :value="1">正常扫码</a-radio>
          <a-radio :value="2">回退扫码</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="扫描二维码" name='code'>
        <a-input style="width: 380px;margin-right: 10px;" v-model:value="form.code" @pressEnter='onSubmit' placeholder="请输入二维码"></a-input>
        <a-button class='m-r-10' type="primary" @click="onSubmit" :loading='submitLoading'>添加</a-button>
        <a-tooltip placement='right'>
          <template #title>
            <p>1、点击“添加”后数据直接保存。如果使用扫描枪设备，不需要点击“添加”按钮，设备扫描完成会自动保存。</p>
            <p>2、使用扫描枪扫描时注意先将“光标”放到输入框中。（鼠标点一下输入框）</p>
            <p>3、程序自带提示音，会根据录入结果提示对应的声音，方便盲扫，请确保电脑带有声音播放功能。</p>
          </template>
          <InfoCircleOutlined class="fz-18" />
        </a-tooltip>
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 12, offset: 2}" v-if='showResult'>
        <div class="p-24 s_bf7">
          <p class="s_lin_h30 s_font_b">本次退货数量计数</p>
          <p class="s_lin_h30">扫码数量：{{scanCodeNum}}</p>
          <p class="s_lin_h30">成功数量：{{successNum}}</p>
          <p class="s_lin_h30">成功商品数量：{{successGoodsNum}}</p>
        </div>
        <a-card class='m-t-10'>
          <p class="s_lin_h30">扫码结果：</p>
          <p class="s_lin_h30">
            <span v-if='form.type == 1'>{{resultCode == 0 ? '退货成功！':'退货失败！'}}</span>
            <span v-else>{{resultCode == 0 ? '回退成功！':'回退失败！'}}</span>
          </p>
          <p class="s_lin_h30" v-if='resultCode != 0'>失败原因：</p>
          <p class="s_lin_h30" v-if='resultCode != 0'>{{resultMsg}}</p>
        </a-card>
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 10, offset: 2}">
        <a-button class="width-100 m-r-20" block @click="()=>{$router.go(-1)}">退出</a-button>
      </a-form-item>
    </a-form>
  </a-card>
</template>

<script>
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { LeftOutlined,InfoCircleOutlined } from "@ant-design/icons-vue";
  import { message } from "ant-design-vue";
  import { iscode } from "@/utils/app";
  import store from "@/store";
  import { getRefundOrderNo,addRefundOrder,getWarehouseList,refundOrderScan,getRefundOrderMore } from "@/api/antiFleeing";
  let defForm = {
    refund_warehousing_sn: '',
    refund_warehouse_id: null,
    refund_warehouse_position_id: null,
    remark: '',
    code:'',
    type:1
  };
  export default {
    components: { LeftOutlined,InfoCircleOutlined },
    setup() {
      const ruleForm = ref();
      const form = ref({ ...defForm });
      const state = reactive({
        submitLoading:false,
        labelCol: {span: 2},
        wrapperCol: {span: 12},
        warehouseList:[],
        warehouseChild:[],
        showResult:false, //是否显示扫码结果
        scanCodeNum:0, //扫码数量
        successNum:0, // 成功数量
        successGoodsNum:0, //成功商品数量
        resultCode:'', //扫码结果code
        resultMsg:'', // 扫码结果提示语
        returnee:'', //退货人
        rules: {
          refund_warehousing_sn: [
            { required: true, message: '退货单号不能为空'}
          ],
          refund_warehouse_id: [
            { required: true, message: '请选择返回仓库',type:'number'}
          ],
          type:[
            { required: true,  message: '请选择扫码类型',type:'number'}
          ],
          code:[
            { required: true,  message: '二维码不能为空'}
          ]
        }
      });
      const $route = inject("$route");
      const $Modal = inject("$Modal");
      const $router = inject("$router");
      // 获取仓库
      const getWarehouse = async () => {
        let res = await getWarehouseList().then(res => res.data);
        if (iscode(res)) {
          state.warehouseList = res.data;
          // 默认选择默认仓库
          form.value.refund_warehouse_id=res.data[0].id
        } else {
          message.error(res.msg);
        }
      }
      //选择仓库
      const selectChange = () =>{
        form.value.refund_warehouse_position_id = null
        var item = state.warehouseList.find(v => v.id == form.value.refund_warehouse_id)
        if(item){
          state.warehouseChild = item.child || []
        }
      }
      // 获取退货单号
      const getOrderNo = async () => {
        let res = await getRefundOrderNo().then(res => res.data);
        if (iscode(res)) {
          form.value.refund_warehousing_sn = res.data.order_no;
        } else {
          message.error(res.msg);
        }
      }
      //获取详情
      const getMore = async () => {
        const hide = message.loading("正在加载中...", 0);
        let res = await getRefundOrderMore($route.query.id ).then((res) => res.data).catch(error => error);
        if (iscode(res)) {
          form.value.refund_warehousing_sn = res.data.refund_warehousing_sn;
          form.value.refund_warehouse_id = res.data.refund_warehouse_id || null;
          form.value.refund_warehouse_position_id = res.data.refund_warehouse_position_id || null;
          form.value.remark = res.data.remark;
          state.returnee = res.data.create_role_name;
          selectChange();
        } else {
          message.error(res.msg);
        }
        setTimeout(hide);
      };
      //提交
      const onSubmit = () => {
        ruleForm.value.validate().then(async() => {
          const hide = message.loading("正在加载中...", 0);
          state.submitLoading = true;
          let res = await addRefundOrder({ ...form.value}).then((res) => res.data).catch(error => error);
          if (iscode(res)) {
            state.scanCodeNum = state.scanCodeNum+1;
            state.successNum = state.successNum+1;
            if(form.value.type==1){ //扫码
              state.successGoodsNum = state.successGoodsNum+res.data.num;
            }else{ //回退
               state.successGoodsNum = state.successGoodsNum-res.data.num;
            }
            
          } else {
            message.error(res.msg);
          }
          state.resultCode = res.code
          state.resultMsg = res.msg
          state.showResult = true
          form.value.code = ''
          setTimeout(hide);
          state.submitLoading = false;
        }).catch(error => {
          message.error('请完善表单！');
        });
      };
      onMounted(() => {
        getWarehouse();
        if($route.query.type == 'add'){
          getOrderNo();
        }else{
          getMore()
        }
      });
      return {
        form,
        ruleForm,
        ...toRefs(state),
        onSubmit,
        selectChange,
        pageType:$route.query.type=='edit', //edit 编辑 list 详情
      };
    },
  };
</script>